




import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class NormalLink extends Vue {
  @Prop() private link!: string;
  @Prop() selfWindow?: boolean;

  get linkTarget() {
    return this.selfWindow ? '_self' : '_blank';
  }
}
